import { MouseEventHandler } from 'react';
import styled from './BankButton.module.scss'
import BankIcon from '../../../../assets/bankIcon.svg'

interface Props {
  children: any;
  onClick: Function
}

const BankButton = ({
  children,
  onClick
}: Props) => {
  return (
    <button className={styled.wrapper} onClick={onClick as MouseEventHandler<HTMLButtonElement>}>
      <img src={BankIcon} />
      {children}
    </button>
  )
}

export default BankButton